<div class="modal fade show d-block" tabindex="-1" role="dialog" style="background-color: rgba(0, 0, 0, 0.5); z-index: 1050" (click)="close()">
    <div class="modal-dialog modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
        <div class="modal-content share-link-modal">
            <div class="modal-header">
                <h5 class="modal-title"><i class="fas fa-share-alt me-2"></i>{{ title }}</h5>
                <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p class="text-muted small mb-3" *ngIf="description">{{ description }}</p>

                <div class="text-center mb-2 qr-display">
                    <qrcode [qrdata]="url" [width]="200" [margin]="2" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
                </div>
                <!-- High-resolution copy used for the PNG download -->
                <div class="qr-print" aria-hidden="true">
                    <qrcode [qrdata]="url" [width]="1024" [margin]="4" [errorCorrectionLevel]="'M'" [elementType]="'canvas'"></qrcode>
                </div>

                <div class="d-flex justify-content-center gap-2 mb-4">
                    <button class="btn btn-sm btn-outline-secondary" (click)="downloadPng()"><i class="fas fa-download me-1"></i>Download PNG</button>
                    <button class="btn btn-sm btn-outline-secondary" (click)="downloadSvg()"><i class="fas fa-download me-1"></i>Download SVG</button>
                </div>

                <div class="mb-3">
                    <div class="input-group input-group-sm">
                        <input type="text" class="form-control" [value]="url" readonly (focus)="$any($event.target).select()" />
                        <button class="btn btn-outline-primary" (click)="copy()"><i class="fas fa-copy me-1"></i>{{ copied ? 'Copied!' : 'Copy' }}</button>
                    </div>
                </div>

                <div class="row g-2">
                    <div class="col-6">
                        <button class="btn btn-outline-success w-100 btn-sm" (click)="whatsapp()"><i class="fab fa-whatsapp me-1"></i>WhatsApp</button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-outline-secondary w-100 btn-sm" (click)="email()"><i class="fas fa-envelope me-1"></i>Email</button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-outline-primary w-100 btn-sm" (click)="linkedIn()"><i class="fab fa-linkedin me-1"></i>LinkedIn</button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-outline-primary w-100 btn-sm" (click)="facebook()"><i class="fab fa-facebook me-1"></i>Facebook</button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-outline-dark w-100 btn-sm" (click)="x()"><i class="fab fa-twitter me-1"></i>X (Twitter)</button>
                    </div>
                    <div class="col-6" *ngIf="canNativeShare">
                        <button class="btn btn-outline-dark w-100 btn-sm" (click)="nativeShare()"><i class="fas fa-ellipsis-h me-1"></i>More apps</button>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>
